import { Box, Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { calculateAllWorkerFRI, getRoles } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import AccessForbidden from "../../../../Access/AccessForbidden";
import Loading from "../../../../../components/Loading/Loading";
import { toast } from "react-toastify";
import { Modal } from "antd";

const FRIButton = () => {
    const {state} = useAuth();
    const [isAdmin, setIsAdmin] = useState(false)
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    
    const calculateAllWorkersFRI = async () => {
        setButtonLoading(true);
        const response = await calculateAllWorkerFRI(state.user?.token);
        if(response?.status === 200) {
            setButtonLoading(false)
            toast.success(response?.data?.message)
        };
    };

    const getAllRoles = async () => {
        const response = await getRoles(state.user?.token);
        if(response) {
            setLoading(false)
        }
        else{
            setIsAdmin(true);
        }
        setLoading(false);
    }

    useEffect(() => {
        getAllRoles()
    }, []);

    if(loading) {
        return <Loading />;
    }

    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <Box m={3}>
            <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={buttonLoading}
                style={{boxShadow: "none", backgroundColor: "#156bc2", width: 222, color: 'white'}}
                onClick={() => 
                    Modal.confirm({
                        title: `This will re-calculate the FRI for all workers. Do you want to continue?`,
                        onOk: () => calculateAllWorkersFRI(),
                        okButtonProps: { danger: true },
                        okText: 'YES',
                        cancelText: 'NO',
                        centered: true
                    })
                }
            >
                Calculate All Fatigues
            </Button>
        </Box>
    )
}

export default FRIButton;